import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";

const Icon = ({ icon, ...props }) => {
  const svg = require(`../../styles/icons/${icon}.svg`);

  return (
    <span
      {...props}
      className={styles.container}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./template/components/Icon/index.js